import React, { Fragment, useState } from 'react'

import classNames from 'classnames'
import {
  CurrentUserCollections,
  ToggleContentCollectionAssociation,
} from 'globalTypes'

import { useMutation, useQuery } from '@apollo/client'
import { Trans } from '@lingui/macro'
import Loading from 'Root/Loader/Page'
import map from 'lodash/map'

import MUTATION_MODULE from '../../../../../Pages/Collection/Component/AssociationContext/AssociateContents/toggle-collection-module-content-association.graphql'
import QUERY from './current-user-collections.graphql'
import MUTATION from './toggle-content-collection-association.graphql'

export interface Props {
  id: any
}

const AssociateToCollections: React.FC<Props> = ({ id }: Props) => {
  const { data, loading } = useQuery<CurrentUserCollections>(QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      includes: id,
    },
  })

  const [modules, setModules] = useState([])
  const [collection, setCollection] = useState()
  const [checkedModule, setCheckedModule] = useState(null)

  const [mutate, { loading: isMutating }] =
    useMutation<ToggleContentCollectionAssociation>(MUTATION)

  const [mutateModule, { loading: isMutatingModule }] =
    useMutation<ToggleContentCollectionAssociation>(MUTATION_MODULE)

  if (loading) {
    return <Loading />
  }

  const collections = map(data?.me?.collections?.edges || [], 'node')

  const onChange = (collection) => async (event) => {
    const checked = event.target.checked

    if (collection.modules.edges.length > 0) {
      setCollection(collection.id)
      const checkModule = collection.modules.edges.find(
        (module) => !!module.node.includes
      )
      checkModule && setCheckedModule(checkModule.node)
      setModules(collection.modules.edges)
    } else {
      await mutate({
        variables: {
          contentId: id,
          collectionId: collection.id,
          associated: checked,
        },
      })
    }
  }

  const onCheckModule = (module) => async (event) => {
    const checked = event.target.checked
    !!checked ? setCheckedModule(module) : setCheckedModule(undefined)
    await mutateModule({
      variables: {
        associated: checked,
        collectionId: collection,
        moduleId: module.id,
        contentId: id,
      },
    })
  }

  if (modules.length > 0) {
    return (
      <Fragment>
        <div className="text-2xl border-b border-gray-300 p-2">
          <Trans>Moduli del corso selezionato</Trans>
        </div>
        <ul className="divide-y divide-gray-200">
          {map(modules, (module) => (
            <li key={module.node.id} className="p-4">
              <label
                className={classNames(
                  {
                    'opacity-50':
                      isMutatingModule ||
                      (!!checkedModule && checkedModule.id !== module.node.id),
                  },
                  'inline-flex items-center cursor-pointer'
                )}
              >
                <input
                  className="cursor-pointer form-checkbox h-8 w-8 rounded-md border-gray-300 p-4"
                  defaultChecked={module.node.includes}
                  onChange={onCheckModule(module.node)}
                  type="checkbox"
                  disabled={
                    isMutatingModule ||
                    (!!checkedModule && checkedModule.id !== module.node.id)
                  }
                />
                <span className="ml-4 text-xl">{module.node.title}</span>
              </label>
            </li>
          ))}
        </ul>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <div className="text-2xl border-b border-gray-300 p-2">
        <Trans>Corsi associati a questo contenuto</Trans>
      </div>
      <ul className="divide-y divide-gray-200">
        {map(collections, (collection) => (
          <li key={collection.id} className="p-4">
            <label
              className={classNames(
                {
                  'opacity-50': isMutating,
                },
                'inline-flex items-center cursor-pointer'
              )}
            >
              <input
                className="cursor-pointer form-checkbox h-8 w-8 rounded-md border-gray-300 p-4"
                defaultChecked={collection.includes}
                onChange={onChange(collection)}
                type="checkbox"
                disabled={isMutating}
              />
              <span className="ml-4 text-xl">{collection.title}</span>
            </label>
          </li>
        ))}
      </ul>
    </Fragment>
  )
}

export default AssociateToCollections
